/**
 * Liste classée (top 5, top 10...)
 * items: [{ label, value, sublabel? }]
 */
export default function TopList({
  title,
  items = [],
  loading = false,
  emptyMessage = "Aucune donnée disponible",
  valueFormatter = (v) => v,
  valueSuffix = "",
}) {
  return (
    <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
      {title && (
        <h3 className="text-lg font-semibold text-[#203a8a] mb-4">{title}</h3>
      )}
      {loading ? (
        <div className="flex items-center justify-center h-48">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#203a8a]"></div>
        </div>
      ) : items.length === 0 ? (
        <div className="flex items-center justify-center h-48 text-gray-500 text-sm">
          {emptyMessage}
        </div>
      ) : (
        <ul className="space-y-3">
          {items.map((item, i) => (
            <li
              key={item.id || i}
              className="flex items-center justify-between gap-3 pb-3 border-b border-gray-100 last:border-0 last:pb-0"
            >
              <div className="flex items-center gap-3 min-w-0">
                <span
                  className={`flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold ${
                    i === 0
                      ? "bg-yellow-100 text-yellow-700"
                      : i === 1
                      ? "bg-gray-100 text-gray-700"
                      : i === 2
                      ? "bg-orange-100 text-orange-700"
                      : "bg-blue-50 text-blue-700"
                  }`}
                >
                  {i + 1}
                </span>
                <div className="min-w-0">
                  <p className="text-sm font-medium text-gray-900 truncate">
                    {item.label}
                  </p>
                  {item.sublabel && (
                    <p className="text-xs text-gray-500 truncate">
                      {item.sublabel}
                    </p>
                  )}
                </div>
              </div>
              <span className="text-sm font-semibold text-[#203a8a] flex-shrink-0">
                {valueFormatter(item.value)}
                {valueSuffix}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
